import { useContext, useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import * as Yup from 'yup';

import { Form, Text } from '../../../Components/Form';
import Loading from '../../../Components/Loading/Loading';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { serverErrorHandler } from '../../../Utils/Helpers';
import { WeightContext } from '../Context/WeightContext';

const validationSchema = Yup.object({
  weight: Yup.string().typeError('وزن الزامی است').required('وزن الزامی است'),
});

const Edit = () => {
  const { id } = useParams();
  const [formSubmitLoading, setFormSubmitLoaing] = useState(false);
  const [serverErrors, setServerErrors] = useState({});
  const { get, put } = useApi();
  const { error, success } = useToast();
  const context = useContext(WeightContext);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getData = async () => {
      await getWeight();
    };
    getData();
  }, [id]);

  const getWeight = async () => {
    setLoading(true);
    await get(
      `/weight/${id}`,
      (res) => {
        context.weight = res.data;
        setLoading(false);
      },
      (err) => {
        error('دریافت اطلاعات با خطا روبرو شد.');
        setLoading(false);
      },
    );
  };

  const submitForm = async (values, setSubmitingForm) => {
    setFormSubmitLoaing(true);
    await put(
      `/weight/${id}`,
      values,
      (res) => {
        success(`وزن "${context?.weight?.weight}" باموفقیت ویرایش شد.`);
        setFormSubmitLoaing(false);
        getWeight();
      },
      (err) => {
        console.log(err);
        if (err?.status === 422) {
          serverErrorHandler(err?.data?.errors, setServerErrors, serverErrors);
          error('لطفا خطاهای فرم را رفع کنید.');
        } else {
          error(`وزن "${context?.weight?.weight}" به علت خطا ایجاد نشد.`);
        }
        setFormSubmitLoaing(false);
      },
    );
  };
  return loading ? (
    <Loading />
  ) : (
    <Master>
      <TitleBar
        title={`ویرایش وزن ${context.weight?.weight} `}
        showBackBtn={true}
        showCreateBtn={false}
        showFilterBtn={false}
        backPath='/weight'
      />
      <Form
        initialValues={{
          weight: context.weight?.weight,
        }}
        loading={formSubmitLoading}
        onSubmit={submitForm}
        validationSchema={validationSchema}
      >
        <div className='row'>
          <div className='col-12'>
            <div className='col-12'>
              <Text
                title='وزن'
                name='weight'
                serverError={serverErrors.weight}
              />
            </div>
          </div>
        </div>
      </Form>
    </Master>
  );
};

export default Edit;
